let titleOp = {
  title: {
    text: '暂未提供'
  }
}
function commZhangHaoServeEchartOp ({ v }) {
  let options = {
    color: ['#3198f7', 'rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '5%',
      top: '25%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      data: [],
      textStyle: {
        color: 'white',
        fontSize: v.fontSizeRem(0.5)
      },
      itemWidth: v.fontSizeRem(0.5),
      itemHeight: v.fontSizeRem(0.5),
      icon: 'circle'
    },
    xAxis: {
      type: 'category',
      data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.4)'
        }
      }
    },
    series: []
  }
  return options
}
export function AccountServiceApplicationUpgrade1EchartOp ({ v, data }) {
  let option = commZhangHaoServeEchartOp({ v })
  option.legend.data = ['升级成功量']
  option.xAxis.data = data.date ?? []
  option.yAxis.name = '万'
  option.series = [
    {
      name: '升级成功量',
      data: data?.data?.map(item => item / 10000) ?? [],
      type: 'line',
      smooth: true,
      symbol: 'none',
      barWidth: v.fontSizeRem(0.6),
      itemStyle: {
        color: '#045cf6'
      }
    }
  ]
  return option
}
export function AccountServiceApplicationUpgrade2EchartOp ({ v, data }) {
  let option = commZhangHaoServeEchartOp({ v })
  option.legend.data = ['升级成功率']
  option.xAxis.data = data?.date ?? []
  option.series = [
    {
      name: '升级成功率',
      data: data?.data ?? [],
      type: 'line',
      smooth: true,
      symbol: 'none'
    }
  ]
  return option
}
export function AccountServiceApplicationUpgrade3EchartOp ({ v, data }) {
  let option = commZhangHaoServeEchartOp({ v })
  option.title = {
    text: '暂未提供数据'
  }
  option.series = [
    {
      name: '用户登录量',
      data: [820, 932, 901, 934, 1290, 1330, 1320],
      type: 'line',
      smooth: true,
      symbol: 'none'
    }
  ]
  return option
}
export function AccountServiceApplicationUpgrade4EchartOp ({ v, data }) {
  let option = commZhangHaoServeEchartOp({ v })
  option.legend.data = ['订阅用户数']
  option.xAxis.data = data?.date ?? []
  option.series = [
    {
      name: '订阅用户数',
      data: data?.data ?? [],
      type: 'line',
      barWidth: v.fontSizeRem(0.6),
      itemStyle: {
        color: '#045cf6'
      },
      smooth: true,
      symbol: 'none'
    }
  ]
  return option
}

export function ChinaMapEchartOp ({ v, data: { max, data } }) {
  let options = {
    tooltip: {
      triggerOn: 'mousemove', // mousemove、click
      padding: 8,
      borderWidth: 1,
      borderColor: '#409eff',
      backgroundColor: 'rgba(255,255,255,0.7)',
      textStyle: {
        color: '#000000',
        fontSize: 13
      }
    },
    visualMap: {
      show: false,
      min: 0,
      max: max,
      text: ['High', 'Low'],
      realtime: false,
      calculable: true,
      inRange: {
        color: ['#00D8FF', '#412ED0', 'red']
      },
      bottom: 0,
      textStyle: {
        color: '#fff'
      }
    },
    geo: {
      map: 'china',
      center: [104.97, 39.71],
      zoom: 1.2,
      top: 0,
      label: {
        normal: {
          show: true,
          fontSize: '11',
          color: '#fff'
        }

      },
      itemStyle: {
        normal: {
          // shadowBlur: 50,
          // shadowColor: 'rgba(0, 0, 0, 0.2)',
          borderColor: 'rgba(0, 0, 0, 0.2)'

        },
        emphasis: {
          areaColor: '#f2d5ad',
          shadowOffsetX: 0,
          shadowOffsetY: 0,
          borderWidth: 0
        }
      },
      regions: [
        // {
        //   name: '南海诸岛',
        //   value: 10
        // }
      ]
    },
    series: [
      {
        type: 'map',
        geoIndex: 0,
        data: [
          // {
          //   name: '广东',
          //   value: 10
          // }
          ...data
        ]
      }
    ]
  }
  return options
}

export function PassEchartOp ({ v, data = { data: [], date: [] } }) {
  let option = commZhangHaoServeEchartOp({ v })
  // option.title = titleOp.title
  option.xAxis.data = [...data.date]
  option.yAxis.name = '万'
  // option.yAxis.axisLabel.formatter = function (value) {
  //   console.log(value)
  //   return (value / 10000).toFixed(2)
  // }
  option.series = [
    {
      name: '服务调用总量',
      data: [...data.data],
      type: 'line',
      smooth: true,
      symbol: 'none'
    }
  ]
  return option
}
export function AccountServiceEchartOp ({ v, data = [] }) {
  let name = []
  let serData = []
  data.forEach(item => {
    name.push(item.secondCategoryName)
    serData.push(item.cnt)
  })
  let option = {
    color: ['#3198f7', 'rgba(255, 95, 165, 1)', 'rgba(0, 114, 255, 1)'],
    grid: {
      left: '5%',
      top: '15%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      show: false
    },
    xAxis: {
      show: false,
      type: 'value',

      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      }
    },
    yAxis: {
      type: 'category',
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(255, 255, 255, 0.4)'
        }
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      data: [...name]
    },
    series: [
      {
        name: '用户登录量',
        data: [...serData],
        type: 'bar'
      }
    ]
  }
  return option
}
export function AuroraEngineEchartOp ({ v, data = { data: [], date: [] } }) {
  let option = commZhangHaoServeEchartOp({ v })
  // option.title = titleOp.title
  // option.title.text = '暂未对接'
  option.xAxis.data = [...(data?.date ?? [])]
  option.series = [
    {
      name: '服务调用总量',
      data: [...(data?.data ?? [])],
      type: 'line',
      smooth: true,
      symbol: 'none'
    }
  ]
  return option
}
export function LifeAssistantEchartOp ({ v, data }) {
  let option = commZhangHaoServeEchartOp({ v })
  let xAxisData = []
  let seriesData = []
  data.forEach(function (item) {
    let { week, usedQty } = item
    xAxisData.push(week)
    seriesData.push(usedQty)
  })
  option.xAxis.data = xAxisData
  option.xAxis.boundaryGap = false

  option.series = [
    {
      name: '标签用量',
      data: [...seriesData],
      type: 'line',
      smooth: true,
      symbol: 'none'
    }
  ]
  return option
}
